<template>
  <div class="SpinnerContainer">
    <span v-if="isOpen" class="Spinner"></span>
  </div>
</template>

<script>
  export default {
    props: {
      isOpen: {
        type: Boolean,
        required: true
      }
    }
  }
</script>

<style scoped>
.SpinnerContainer {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.Spinner {
  display: inline-block;
  width: 48px;
  height: 48px;
  box-sizing: border-box;
  border: 5px solid #000;
  border-bottom-color: transparent;
  animation: rotation 1s linear infinite;
  border-radius: 50%;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
} 
</style>